import React, { useState, useEffect } from 'react';
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { ThemeProvider } from '../../themes/ThemeProvider';
import { processEndpointValues, restructureObject } from '../moduleUtils/apiObjectFormatting';
import FormField from '../baseElements/FormField';
import ModuleContainer from '../baseElements/ModuleContainer';
import ModuleHeader from '../baseElements/ModuleHeader';
import ModuleDescription from '../baseElements/ModuleDescription';
import ModuleBody from '../baseElements/ModuleBody';
import InfoComponent from '../../elements/InfoComponent';
import ButtonComponent from '../../elements/ButtonComponent';
import moduleConfig from './csJobModuleConfig';

const CsJobModule = ({ id, data }) => {
  // API CALL CONTEXT
  const { moduleNodes, registerModule, updateModuleConfig, updateApiParams, setExecutionOrder, toggleModuleActive, sharedParams, state, isExecuting, isCloudProcessRunning } = useApi();
  const [endpointValues, setEndpointValues] = useState(() => {
    return moduleNodes[id] || 
      {
  "endpoint_0": {
    "path": "/api2/cloudslicer/jobs/create",
    "method": "POST",
    "root_url": "https://services.uplynk.com",
    "params": {
      "args.description": "Tears",
      "args.trim": "0,30000",
      "args.slicer_args": "-audiodesc \\\"English\\\" -atrack 0 -drm_mode none",
      "source.url": "https://www.dropbox.com/scl/fi/9qopbcyd15jei49v6seh2/Tears-of-Steel.mp4?rlkey=ac47bz4dwo72a4ogfh44sn108&dl=1",
      // "source.url": "https://www.dropbox.com/scl/fi/nozpqqe04jj9zqro0e9u4/Japanese-Neon-Street-KlingAI.mp4?rlkey=z10a79rm3olbac16itxnlerd4&dl=1"
    }
  }
};
});
  const [results, setResults] = useState(null);
  const [isModified, setIsModified] = useState(false);
  const isProcessing = isExecuting || isCloudProcessRunning;

 
  // Handle form field changes by updating the specific endpoint parameter directly
  const handleChange = (endpointKey, paramName, value) => {
    setEndpointValues(prev => ({
      ...prev,
      [endpointKey]: {
        ...prev[endpointKey],
        params: {
          ...prev[endpointKey].params,
          [paramName]: value
        }
      }
    }));
    setIsModified(true);
  };

  // Handle form submission with API context integration
  const handleSubmit = async () => {
    try {
      // Process the endpoint values
      const processedData = processEndpointValues(endpointValues, moduleConfig);
      
      if (!moduleNodes[id]) {
        // Module not registered - register it
        const moduleLabel = data?.label || '';
        const moduleData = {
          ...endpointValues,
          callbacks: moduleConfig.moduleConfig.callbacks,
        };
        registerModule(id, moduleData, moduleLabel, processedData.validation);
      } else {
        // Module exists - update it
        updateModuleConfig(id, processedData.endpoints, processedData.validation);
      }
      
      setIsModified(false);
    } catch (error) {
      console.error('Error processing form:', error);
    }
  };

  // Register module on mount
  useEffect(() => {
    if (!id) return;

    if (!moduleNodes[id]) {
      const moduleLabel = data?.label || '';

      // Process the endpoint values to get validation results
      const processedData = processEndpointValues(endpointValues, moduleConfig);
      
      // Create the full module data including callbacks
      const moduleData = {
        ...endpointValues,
        callbacks: moduleConfig.moduleConfig.callbacks, // Include callbacks from the module config
      };
      
      // Register module with all data including callbacks
      registerModule(id, moduleData, moduleLabel, processedData.validation);
    } else {
      // If module exists, use its data including any callbacks
      setEndpointValues(moduleNodes[id]);
    }

    // Clean up when component unmounts
    return () => {
      // Any cleanup code
    };
  }, []);
  
  
  return (
      <ThemeProvider themeKey="manifest" size="small"> 
        <ModuleContainer>
          <ModuleHeader title="Cloud Slicer" />
          <ModuleDescription description="Add Files to Uplynk" />
          {/* <ModuleBody endpoints={moduleConfig.moduleConfig.endpoints} readyState={moduleNodes[id]?.readyState}> */}
          <ModuleBody endpoints={moduleConfig.moduleConfig.endpoints} readyState={moduleNodes[id]?.readyState && !isModified} activeState={moduleNodes[id]?.activeState} toggleModuleActive={toggleModuleActive} id={id}>
              {/* Field: args.description for /api2/cloudslicer/jobs/create */}
              <FormField 
                type="text"
                label="Title"
                value={endpointValues['endpoint_0']?.params?.['args.description']}
                onChange={(value) => handleChange('endpoint_0', 'args.description', value)}
                placeholder="Tears of steel"
              />

              {/* Field: source.url for /api2/cloudslicer/jobs/create */}
              <FormField 
                type="text"
                label="trim"
                value={endpointValues['endpoint_0']?.params?.['args.trim']}
                onChange={(value) => handleChange('endpoint_0', 'args.trim', value)}
                required={true}
                placeholder="0,30000"
              />

              {/* Field: source.url for /api2/cloudslicer/jobs/create */}
              <FormField 
                type="textarea"
                label="url"
                value={endpointValues['endpoint_0']?.params?.['source.url']}
                onChange={(value) => handleChange('endpoint_0', 'source.url', value)}
                required={true}
                placeholder="https://www.dropbox.com/scl/fi/9qopbcyd15jei49v6seh2/Tears-of-Steel.mp4?rlkey=ac47bz4dwo72a4ogfh44sn108&dl=1"                
              />

              <ButtonComponent 
                id="button_1741528109211"
                label={isProcessing ? "Processing..." : "Apply"}
                variant={isProcessing ? "secondary" : "primary"}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSubmit();
                }}
                readyState={!isProcessing && moduleNodes[id]?.readyState && !isModified}
                executing={isProcessing}
                disabled={isProcessing}
                isProcessing={isProcessing}
              />

          </ModuleBody>
        </ModuleContainer>
      </ThemeProvider>
    );
}


export default CsJobModule;